import api from '../api';
import { CreateGroupRequest, CreateGroupResponse, UpdateGroupRequest } from '@ilteducation/customer-mgmt-types';
import { ref } from 'vue';

export const useEditGroup = () => {
  const error = ref<null | unknown>(null);
  const isLoading = ref<boolean>(false);

  const createGroup = async (data: CreateGroupRequest): Promise<CreateGroupResponse> => {
    error.value = null;
    isLoading.value = true;
    try {
      const response = await api.group.create(data);
      error.value = null;
      isLoading.value = false;
      return response.data;
    } catch (err: unknown) {
      console.error(err);
      error.value = err;
      isLoading.value = false;
      return Promise.reject(err);
    }
  };

  const updateGroup = async (groupUid: string, data: Omit<UpdateGroupRequest, 'groupUid'>) => {
    error.value = null;
    isLoading.value = true;
    try {
      const response = await api.group.patch(groupUid, data);
      error.value = null;
      isLoading.value = false;
      return response.data;
    } catch (err: unknown) {
      console.error(err);
      error.value = err;
      isLoading.value = false;
      return Promise.reject(err);
    }
  };

  const deleteGroup = async (groupUid: string): Promise<boolean> => {
    error.value = null;
    isLoading.value = true;

    try {
      isLoading.value = true;
      await api.group.delete(groupUid);
    } catch (err: unknown) {
      console.error(err);
      error.value = err;
      isLoading.value = false;
      return false;
    }

    error.value = null;
    isLoading.value = false;
    return true;
  };

  const addMember = (groupUid: string, userUid: string) => {
    isLoading.value = true;
    error.value = null;

    return api.group
      .addMember(groupUid, userUid)
      .then(() => {
        isLoading.value = false;
        error.value = null;
      })
      .catch((err: unknown) => {
        console.error(err);
        error.value = err;
        isLoading.value = false;
        return Promise.reject(err);
      });
  };

  const removeMember = (groupUid: string, userUid: string) => {
    isLoading.value = true;
    error.value = null;
    return api.group
      .removeMember(groupUid, userUid)
      .then(() => {
        isLoading.value = false;
        error.value = null;
      })
      .catch((err: unknown) => {
        console.error(err);
        error.value = err;
        isLoading.value = false;
        return Promise.reject(err);
      });
  };

  return {
    createGroup,
    updateGroup,
    deleteGroup,
    addMember,
    removeMember,
    isLoading,
    error,
  };
};
